import { render } from "./dashboardFacade.vue?vue&type=template&id=1585c0cd"
import script from "./dashboardFacade.vue?vue&type=script&lang=js"
export * from "./dashboardFacade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__